module.exports = __webpack_public_path__ + "media/small-arrow.eff737a2.svg";